// FIXME: environment
// import { compose, ActionReducer } from '@ngrx/store';
import { ActionReducer, MetaReducer } from '@ngrx/store';
import { storeLogger } from 'ngrx-store-logger';
// FIXME: environment
// import { combineReducers } from '@ngrx/store';

import * as logic from './logics';
import { STORE_DEV_TOOLS } from './constants';

export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
  return storeLogger()(reducer);
};

let reducersKeys = Object.keys(logic)
  .filter(key =>
    key.substr(-7) === 'Reducer')
  , reducersMap;

reducersMap = {};
for (let i in reducersKeys) {
  reducersMap[reducersKeys[i].replace('Reducer', '')] = logic[reducersKeys[i]];
}

export const metaReducers: MetaReducer<any>[] | null = STORE_DEV_TOOLS === 'logger' ? [logger] : null;

export const rootReducer = Object.assign({}, reducersMap);

// FIXME: controllare resetOnLogout
/* const resetOnLogout = (reducer: Function) => {
  return function (state, action) {
    let newState;
    if (action.type === '[User] Logout Success') {
      newState = Object.assign({}, state);
      Object.keys(models).forEach((key) => {
        newState[key] = models[key];
      });
    }
    return reducer(newState || state, action);
  };
};

const productionReducer = compose(resetOnLogout, combineReducers)(reducers);

export function rootReducer(state: any, action: any) {
  return productionReducer(state, action);
} */



// WEBPACK FOOTER //
// ./src/app/app.reducers.ts